export function canLinkAircallAccount(user) {
  return (user.role === 'teleoperator' || user.role === 'manager') && user.status === 'active'
}

export function isLinkedToAircallAccount(user) {
  return !!user.aircallId
}

export function hasIncompleteAircallAccount(user) {
  return canLinkAircallAccount(user) && !isLinkedToAircallAccount(user)
}

export function getFullName(user) {
  return `${user.firstName} ${user.lastName}`.trim()
}

export function canProcessLead(user) {
  return ['teleoperator', 'manager'].includes(user.role)
}

export function canCallLead(user) {
  return canProcessLead(user)
}

export function canSearchLead(user) {
  return ['teleoperator', 'manager', 'administrator'].includes(user.role)
}

export function isLeadBeingProcessedByAnotherUser(lead, connectedUser) {
  if (!lead.processingUser) return false

  return lead.processingUser.id !== connectedUser.id
}
